import {
    SET_SORTING_OPTIONS
} from 'common/actions/fileSortingOptions';
import lodash from 'lodash';

export function setSortingOptions(state, action) {
    if(!action || action.type !== SET_SORTING_OPTIONS){
        return state;
    }

    const sortingOptions = action.payload;

    const app = {...state.app};
    app.fileSortingOptions = lodash.clone(sortingOptions);

    return {
        ...state,
        app
    };
}

export default setSortingOptions;